import Card from "@components/Card";
import { useAuthContext } from "@contexts/auth";
import { useProjectContext } from "@contexts/projects";
import { cardTexts } from "@utils/cardTexts";
import { checkIfCubBased, checkLabel, formatNumberToLocale } from "@utils/formatNumber";
import { Fragment } from "react";
import ScheduleSourceStatus from "../schedule/ScheduleSourceStatus";
import AnnulmentIndicator from "@components/titleAnnulments/AnnulmentIndicator";

const Agregator = () => {
  const { activeProject, cubBased } = useProjectContext();
  const { predicted, measured, budget, lastMeasure, paidValue, cubValue } = activeProject

  const { user: { configurations: { value: { cards } } } } = useAuthContext();

  const getPaid = () => {
    if (cubBased) return cubValue
    return checkIfCubBased(paidValue)
  }

  const formatScheduleValue = (value) => (
    value !== null && value !== undefined && Number.isFinite(Number(value))
      ? formatNumberToLocale(checkIfCubBased(value))
      : "—"
  )

  const checkCard = (i) => {
    switch (i) {
      case 'predicted':
        return <Card label={checkLabel('Valor previsto')} content={formatScheduleValue(predicted?.value)} tooltip={cardTexts.EXPECTED} />
      case 'measured':
        return <Card label={checkLabel('Valor medido')} content={formatScheduleValue(measured?.value)} />
      case 'paid':
        // O tooltip fala em R$; com a obra em CUB o valor da tela não está em reais.
        return <Card label={checkLabel('Valor pago')} content={formatNumberToLocale(getPaid())} indicator={cubBased ? null : <AnnulmentIndicator summary={activeProject.titleAnnulments} kind="paid" />} />
      default:
        break;
    }
  }

  return (
    <div className="grid gap-24 columns-5-laptop margin-top-40">
      <div className="column-span-5">
        <hgroup className="dashboard-title flex wrap-wrap gap-16 align-center justify-content-space-between">
          <h2>Valor agregado</h2>
        </hgroup>
      </div>
      {/* A fonte das curvas é informação dos cards: ícone no canto inferior direito. */}
      <div className="column-span-5 info-anchor info-anchor--padded">
        <div className="grid columns-2-tablet columns-4-laptop-l gap-16">
          {cards.map(i => {
            return <Fragment key={i}>{checkCard(i)}</Fragment>
          })}
        </div>
        <ScheduleSourceStatus metadata={activeProject?.scheduleSource} />
      </div>
    </div>
  )
};

export default Agregator;
